{
  "valid": "Giltig"
}
